import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { HomeComponent } from './page/home/home.component';
import { MatCardModule } from '@angular/material/card';
import { PayerComponent } from './page/payer/payer.component';
import { EventComponent } from './page/event/event.component';
import { RestaurantComponent } from './page/restaurant/restaurant.component';
import { ActiviteComponent } from './page/activite/activite.component';
import { MatIconModule } from '@angular/material/icon';
import { ManjocarnComponent } from './page/manjocarn/manjocarn.component';
import { CarteComponent } from './page/carte/carte.component';
import { HttpClientModule } from '@angular/common/http';
import { InstagramComponent } from './page/instagram/instagram.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SectionHeaderComponent } from './shared/section-header/section-header.component';
import { FooterComponent } from './shared/footer/footer.component';
import { ScrollRevealDirective } from './shared/scroll-reveal/scroll-reveal.directive';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    PayerComponent,
    EventComponent,
    RestaurantComponent,
    ActiviteComponent,
    ManjocarnComponent,
    CarteComponent,
    InstagramComponent,
    SectionHeaderComponent,
    FooterComponent,
    ScrollRevealDirective,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MatCardModule,
    MatIconModule,
    HttpClientModule,
    MatProgressSpinnerModule,
    BrowserAnimationsModule,
  ],
  providers: [provideAnimationsAsync()],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
